<div class="cell-icon {{iconClass}}"
    [ngClass]="{'collapsed': isCollapsed}"
    *ngIf="iconClass"
    (click)="onClick($event)">
</div>

<div sa-ellipsis [fullText]="value"
    class="cell-value"
    [ngClass]="{'na-color': isNotApplicable(), 'nested-row': isInANestedRow}">
</div>